export const SubscriptionCardStatusEnum = {
    REGISTER: '사용가능(빌링키 발급전)',
    USE: '사용중',
    CANNOT_USE: '사용불가'
}